export const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_WARNING_MESSAGE = "SET_WARNING_MESSAGE";
export const CLOSE_AND_RESET_NOTIFICATION = "CLOSE_AND_RESET_NOTIFICATION";
